"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditScoreVerifiableFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var CreditScoreVerifiableFactory = /** @class */ (function (_super) {
    __extends(CreditScoreVerifiableFactory, _super);
    function CreditScoreVerifiableFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    CreditScoreVerifiableFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    CreditScoreVerifiableFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    CreditScoreVerifiableFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    CreditScoreVerifiableFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    CreditScoreVerifiableFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return CreditScoreVerifiableFactory;
}(contracts_1.ContractFactory));
exports.CreditScoreVerifiableFactory = CreditScoreVerifiableFactory;
var _abi = [
    {
        constant: true,
        inputs: [],
        name: "creditScoreContract",
        outputs: [
            {
                internalType: "contract ISapphireCreditScore",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b5060d28061001f6000396000f3fe6080604052348015600f57600080fd5b506004361060285760003560e01c806303a42b6f14602d575b600080fd5b60336047565b604051603e91906063565b60405180910390f35b6000546001600160a01b031681565b605d816081565b82525050565b60208101606f82846056565b92915050565b6001600160a01b031690565b6000606f826000606f82607556fea365627a7a7231582062e0d80607c7ef0e50204be4865c1b511e6f76b253afb31fde2587008eafbe1f6c6578706572696d656e74616cf564736f6c63430005100040";
